import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/close_icon.png'


const _hoisted_1 = { class: "my-list-foloder-dialog-overlay" }
const _hoisted_2 = { class: "my-list-foloder-dialog-box" }
const _hoisted_3 = { class: "my-list-foloder-dialog-box-area" }
const _hoisted_4 = { class: "my-list-foloder-dialog-header-area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "my-list-foloder-dialog-title-text" }, "マイページに追加", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "my-list-foloder-dialog-close-image-icon",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "my-list-foloder-dialog-scroll-area" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "my-list-foloder-dialog-list-empty-view" }, null, -1)
const _hoisted_9 = { class: "my-list-foloder-dialog-button-view-area" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "my-list-foloder-dialog-button-text" }, "追加", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyListFolderList = _resolveComponent("MyListFolderList")

  return (_openBlock(), _createBlock(_Transition, _mergeProps({ name: "my-list-foloder-dialog" }, _ctx.computeShowDialog), {
    default: _withCtx(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", {
                class: "my-list-foloder-dialog-close-image",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClose(...args)))
              }, [
                _hoisted_6
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_MyListFolderList, {
              class: "my-list-foloder-dialog-list-area",
              folderList: _ctx.folderList,
              checkedId: _ctx.checkedId,
              onSelectCheck: _ctx.selectCheck
            }, null, 8, ["folderList", "checkedId", "onSelectCheck"]),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", {
              class: "my-list-foloder-dialog-button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickPositive(...args)))
            }, [
              _hoisted_10
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showDialog]
      ])
    ]),
    _: 1
  }, 16))
}